import React from 'react'
import { Col, Image } from 'react-bootstrap'
import 'tachyons';
import reactImg from '../../IMGS/react.svg'
import angularImg from '../../IMGS/angular_simple.svg'
import nodeImg from '../../IMGS/nodejs.svg'
import mongoImg from '../../IMGS/Mongodb.png'
import javaImg from '../../IMGS/javaLogo.svg'
import vuejs from '../../IMGS/vuejs.svg'
import graphqlImg from '../../IMGS/GraphQL_Logo.svg'
import expressjsImg from '../../IMGS/expressjs.svg'

let codeLangList = [
    {
      name: "React",
      image: reactImg,
      description: "A JavaScript library for building user interfaces.",
      projsBuilt: 4,
      link: "https://reactjs.org/"
    },
    {
      name: "Angular",
      image: angularImg,
      description: "A structural framework for dynamic web apps",
      projsBuilt: 1,
      link: "https://angular.io/"
    },
    {
      name: "Vue",
      image: vuejs,
      description: "A progressive framework for building user interfaces",
      projsBuilt: 2,
      link: "https://vuejs.org/"
    },
    {
      name: "Express",
      image: expressjsImg,
      description: "Fast, unopinionated, minimalist web framework for Node.js",
      projsBuilt: 4,
      link: "https://expressjs.com/"
    },
    {
      name: "Node",
      image: nodeImg,
      description: "A JavaScript runtime built on Chrome's V8 JavaScript engine",
      projsBuilt: 4,
      link: "https://nodejs.org/en/"
    },
    {
      name: "MongoDB",
      image: mongoImg,
      description: "A free and open-source cross-platform document-oriented database program.",
      projsBuilt: 4,
      link: "https://www.mongodb.com/"
    },
    {
      name: "Java",
      image: javaImg,
      description: "A programming language and computing platform first released by Sun Microsystems in 1995.",
      projsBuilt: 4,
      link: "https://www.mongodb.com/"
    },
    {
      name: "GraphQL",
      image: graphqlImg,
      description: "A query language for APIs and a runtime for fulfilling those queries with your existing data.",
      projsBuilt: 2,
      link: "https://graphql.org/"
    }
]

function Tech(){
  return( 
        <Col className="flex flex-wrap" sm={12} md={12} lg={12} id="tech">
          <h2 className="display-5 w-100 roboto b">Tech That I Work With</h2>
            {
              codeLangList.map( (eachTech) => {
                return(
                  <Col className="grow mb3" key={eachTech.name} sm={12} md={6} lg={3}>
                    <Image className="card-img-top" src={eachTech.image} alt="technologies I work with" height="250" responsive/>
                    <div className="card-body v-btm ma2">
                      <h5 className="card-title">{eachTech.name}</h5>
                      <p className="card-text">{eachTech.description}</p>
                      <a href={eachTech.link} className="btn btn-primary" style={{position: "absolute", bottom: 0, left: 50, right: 50}}>Docs</a>
                    </div> 
                  </Col>     
                )
              })
            }
          </Col>  
  )
}
export default Tech 